<ion-content>
  <div class="unauthorized-container">
    <div class="card">
      <div class="icon-wrapper">
        <span class="icon">🔒</span>
      </div>

      <h1>Access Denied</h1>
      <p>
        Oops! It looks like you don't have the necessary permissions to view this page.
        If you think this is a mistake, please reach out to your system administrator.
      </p>

      <div class="actions">
        <button class="btn primary" (click)="goHome()" aria-label="Navigate to home page">
          Go to Home
        </button>
      </div>
    </div>
  </div>
</ion-content>
